module.exports = __webpack_public_path__ + "img/wallet.db38eaf1.png";